<script>
export default {
  props: {
    classSpinner: { type: String, default: '' },
  },

  computed: {
    classForSpinner: function () {
      let classResult = 'w-100'
      let splitClass = this.classSpinner.split(' ')
      if (
        !splitClass.find(function (val) {
          return val === 'text-right' || val === 'text-center' || val === 'text-left'
        })
      ) {
        classResult += ' text-left'
      }
      if (
        !splitClass.find(function (val) {
          return val.substring(0, 3) === 'fs-'
        })
      ) {
        classResult += ' fs-14'
      }
      if (
        !splitClass.find(function (val) {
          return val.substring(0, 3) === 'fw-'
        })
      ) {
        classResult += ' fw-700'
      }
      if (this.classSpinner && this.classSpinner.length > 0) {
        classResult += ' ' + this.classSpinner
      }

      return classResult.trim()
    },
  },
}
</script>
<template>
  <div :class="classForSpinner" e2e-block="waitingText">
    <slot>{{ $t('main.waiting') }}</slot
    >&nbsp;&nbsp;&nbsp;
    <div class="spinner-dots" style="display: inline">
      <span class="dot1"></span>
      <span class="dot2"></span>
      <span class="dot3"></span>
    </div>
  </div>
</template>
